module.exports = __webpack_public_path__ + "img/img4.7a213477.png";